import React, { ReactNode } from 'react'

import { FormattedMessage } from '@divvy-web/i18n'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import { URL } from '@sputnik/resources/constants'

interface TermsAndConditionsLinkProps {
  dataTestId?: string
  className?: string
  alternateLinkString?: ReactNode
  onClick?: () => void
}

const TermsAndConditionsLink = ({
  dataTestId,
  className,
  alternateLinkString,
  onClick,
}: TermsAndConditionsLinkProps) => {
  const { BILL_TERMS_AND_CONDITIONS } = URL

  return (
    <TextLink
      className={className}
      dataTestId={dataTestId}
      href={BILL_TERMS_AND_CONDITIONS}
      size={TextLinkSizes.REGULAR}
      target='_blank'
      useDataTestId={dataTestId}
      onClick={onClick}
    >
      {!alternateLinkString && (
        <FormattedMessage
          defaultMessage='Terms & Conditions'
          id='sputnik.TermsAndConditionsLink__arPp4e'
        />
      )}
      {alternateLinkString && alternateLinkString}
    </TextLink>
  )
}

export default TermsAndConditionsLink
